import { useState } from 'react';
import {
  AssociationAutocomplete,
  IAssociationChoiceProps,
} from './AssociationAutocomplete';
import { ICustomValidValues } from '../../../../../../Types/ColumnDefType';
import { useOptions } from '../../../Hooks/useAssociationValues';

interface IProps extends IAssociationChoiceProps {
  collectionName: string;
  headerDefs: string[];
  required?: boolean;
  marker?: boolean;
  inGrid?: boolean;
  tooltip?: string | null;
  disabled?: boolean;
  errorMessage?: string;
  warningMessage?: string;
  hintMessage?: string;
  fullWidth?: boolean;
  validValues?: ICustomValidValues;
  dataTestid?: string;
}
export const AssociationChoice: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const [open, setOpen] = useState(false);

  const options = useOptions(
    props.collectionName,
    props.headerDefs,
    undefined,
    props.value,
    open,
    props.validValues
  );
  return (
    <AssociationAutocomplete
      label={props.label}
      value={props.value || ''}
      onAssociationSelected={props.onAssociationSelected}
      options={options}
      size={props.size}
      editMode={props.editMode}
      noMargin={props.noMargin}
      relativeSize
      required={props.required}
      requiredMessage={props.requiredMessage}
      marker={props.marker}
      inGrid={props.inGrid}
      tooltip={props.tooltip}
      disabled={props.disabled}
      errorMessage={props.errorMessage}
      warningMessage={props.warningMessage}
      hintMessage={props.hintMessage}
      fullWidth={props.fullWidth}
      hideLabel={props.hideLabel}
      hideOutline={props.hideOutline}
      allMargins={props.allMargins}
      leftMargin={props.leftMargin}
      rightMargin={props.rightMargin}
      topMargin={props.topMargin}
      bottomMargin={props.bottomMargin}
      inputMargin={props.inputMargin}
      disableArrowIcon={props.disableArrowIcon}
      lineMarker={props.lineMarker}
      inputRef={props.inputRef}
      disableDisabledBackgroundColor={props.disableDisabledBackgroundColor}
      testId={props.testId}
      onBlur={props.onBlur}
      setOpen={setOpen}
    />
  );
};
